module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nyn-0e8124bc97fa3440feef77db6aaac359.png";